import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { CORE_STATE_NAME } from "@core/redux/reducer/common/core.reducer";

@Component({
  selector: "side-bar",
  templateUrl: "./side-bar.component.html"
})
export class SideBarComponent {

  private _clickToCall: string;
  private _startChat: string;
  private _callBack: string;

  private coreState: Observable<any>;

  constructor(private _ngrxStore: Store<any>) {
    this.coreState = _ngrxStore.select(CORE_STATE_NAME);
    this.coreState.subscribe(state => {
      this.clickToCall = state.clickToCall || null;
      this.startChat = state.startChat || null;
      this.callBack = state.callBack || null;
    });
  }

  set clickToCall(callNo: string) {
    this._clickToCall = callNo;
  }

  get clickToCall(): string {
    return this._clickToCall;
  }

  get clickToCallHref(): string {
    return "tel:" + this._clickToCall;
  }

  set startChat(chatLink: string) {
    this._startChat = chatLink;
  }

  get startChat(): string {
    return "https://" + this._startChat;
  }

  set callBack(callBackLink: string) {
    this._callBack = callBackLink;
  }

  get callBack(): string {
    return "https://" + this._callBack;
  }
}
